import * as React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} viewBox="0 0 25 24" {...props} fill="none">
        <Path
            clipRule="evenodd"
            d="M16.056 17.757c-2 2-3 3-4.243 3-1.243 0-2.243-1-4.243-3L5.843 16.03c-1.156-1.156-1.734-1.734-2.039-2.47-.304-.734-.304-1.552-.304-3.187V9c0-2.828 0-4.243.879-5.121C5.257 3 6.672 3 9.5 3h1.373c1.635 0 2.453 0 3.188.304.735.305 1.313.883 2.47 2.04l1.726 1.726c2 2 3 3 3 4.243 0 1.243-1 2.243-3 4.243l-2.201 2.201z"
            stroke={props.fill || designSystem.colors.gray3}
            strokeWidth={1.75}
        />
        <Circle
            cx={9.17685}
            cy={8.64014}
            r={1.36957}
            transform="rotate(-45 9.177 8.64)"
            fill={props.fill || designSystem.colors.gray3}
        />
    </Svg>
);
export default SvgComponent;
